<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="isRoleEditable"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [offsetRect]="offsetRect"
  [zoomScale]="zoomScale"
  [role2ColorMapping]="role2ColorMapping"
  [isEditableGuestDataDictField]="isEditableGuestDataDictField"
  resizableEdges="w,e"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
  (roleChange)="onRoleChange($event)"
>
  <ng-container class="title">
    <i class="far fa-check-square mr-2"></i> <ng-container i18n>Data Dict</ng-container>
  </ng-container>
  <ng-container class="label"> <i class="far fa-book"></i> {{ label }} </ng-container>
</app-field-renderer>
